import { TextBlock } from './TextBlock';
import { ErrorBlock } from './ErrorBlock';
import { JobBlock } from './job';
import { JobListBlock } from './jobList';
import { ContactListBlock } from './contactList';
import { CandidateBlock } from './candidate';
import { ClarifyBlock } from './clarify';
import { ClarifyFormBlock } from './clarifyForm';
import { ResumeBlock } from './resume';
import { DataTableBlock } from './dataTable';
import { CandidateProfilesBlock } from './candidateProfiles';
import { EmailComposeBlock } from './emailCompose';
import { ActionResultBlock } from './actionResult';
import { InterviewListBlock } from './interviewList';
import { DashboardBlock } from './dashboard';
import { ApprovalBlock } from './approval';
import { IcpBlock } from './icp';
import { EntityBlock } from './entity';
import { FileBlock } from './file';
import { DownloadBlock } from './download';
import { FlowBlock } from './flow';
import type { BlockRegistry } from './registry.types';

// Maps a block `type` to its renderer. Each entry expects props of the shape
// `{ data: <variant data> }`. Every BlockOutput variant has an entry — a
// backend payload must never render as blank space. actionResult doubles as
// the generic fallback for unknown entities.
export const BLOCK_REGISTRY: BlockRegistry = {
  text: TextBlock,
  error: ErrorBlock,
  job: JobBlock,
  jobList: JobListBlock,
  contactList: ContactListBlock,
  candidate: CandidateBlock,
  clarify: ClarifyBlock,
  clarifyForm: ClarifyFormBlock,
  resume: ResumeBlock,
  dataTable: DataTableBlock,
  candidateProfiles: CandidateProfilesBlock,
  emailCompose: EmailComposeBlock,
  actionResult: ActionResultBlock,
  interviewList: InterviewListBlock,
  dashboard: DashboardBlock,
  approval: ApprovalBlock,
  icp: IcpBlock,
  entity: EntityBlock,
  file: FileBlock,
  download: DownloadBlock,
  flow: FlowBlock,
};
